import TargetedLandingErrorContent from 'components/Content/TargetedLandingPromotion/TargetedLandingErrorContent/TargetedLandingErrorContent';

export default TargetedLandingErrorContent;
